import { render, staticRenderFns } from "./topTabs.vue?vue&type=template&id=1c76a5b4&scoped=true"
import script from "./topTabs.vue?vue&type=script&lang=js"
export * from "./topTabs.vue?vue&type=script&lang=js"
import style0 from "./topTabs.vue?vue&type=style&index=0&id=1c76a5b4&prod&lang=scss"
import style1 from "./topTabs.vue?vue&type=style&index=1&id=1c76a5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c76a5b4",
  null
  
)

export default component.exports